import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { Api } from '../utils';

// [2026-04-25] Processes account setup via email by reading either ?session_id or?email (from Stripe success_url or the "Welcome Gatherly" email).
// Redirects to the login page if it's already verified.
// Ensures the user completes registration.
export const useCompleteAccountEmail = (): {
  email: string;
  loading: boolean;
} => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Retrieves the query parameters from the URL (?email or ?session_id)
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get('email');
    const sessionId = params.get('session_id');

    // [2026-04-29] User arrives with ?email (ej. from the email “Welcome to Gatherly”)
    if (emailParam) {
      Api.getUserStatus(emailParam)
        .then(({ status }) => {
          if (status === 'FORCE_CHANGE_PASSWORD') {
            setEmail(emailParam);
            setLoading(false);
          } else {
            // If this is CONFIRMED in or NOT_FOUND → redirect to sign-in page
            // (prevents users who are already logged in from having to sign up again)
            setLocation('/');
          }
        })
        .catch(() => setLoading(false));
      return;
    }

    // User arrives with ?session_id (from the Stripe success URL)
    if (sessionId) {
      Api.getCheckoutSession(sessionId)
        .then(({ email: sessionEmail }) => {
          // Retrieves the email address from the Stripe session
          // and allows account setup process to continue
          setEmail(sessionEmail);
          setLoading(false);
        })
        .catch(() => setLoading(false));
      return;
    }

    setLoading(false);
  }, []);

  return { email, loading };
};
